import ChatFeed from "@/components/ChatFeed";
import { useNavigate } from "react-router-dom";

export default function ChatTab({ chantierId }) {
  const nav = useNavigate();
  return (
    <div className="h-[calc(100vh-20rem)] min-h-[400px]">
      <ChatFeed
        chantierId={chantierId}
        placeholder="Message pour l'équipe du chantier…"
        title="Chat chantier"
        onClose={() => nav(`/chantiers/${chantierId}`)}
      />
    </div>
  );
}
